import { MetricType, PerformanceStatus, PerformanceTimePeriod } from '@core/enums';

export { MetricType, PerformanceStatus, PerformanceTimePeriod } from '@core/enums/performance.enum';

export type MetricKey =
  | 'averageConfirmationTime'
  | 'averageLeadTime'
  | 'throughput'
  | 'percentageOfForecastsFinalisedUnder30Days'
  | 'otif'
  | 'lateOrders'
  | 'orderCycleTimeVariability'
  | 'orderRequiringRevision'
  | 'percentageOfBatchesInExtendedQc'
  | 'numberOfStockOutIncidents'
  | 'numberOfExpiredInventoryBatches'
  | 'percentageOfSkusAtLowStockLevel'
  | 'dataCompletenessRateConfirmations'
  | 'dataCompletenessRateOrders'
  | 'forecastRevisionRate'
  | 'avgFrequencyOfImports';

export const METRIC_LABELS: Record<MetricKey, string> = {
  averageConfirmationTime: 'Average Confirmation Time',
  averageLeadTime: 'Average Lead Time',
  throughput: 'Average Throughput',
  percentageOfForecastsFinalisedUnder30Days: 'Forecasts Finalised Under 30 Days',
  otif: 'OTIF Rate',
  lateOrders: 'Late Orders',
  orderCycleTimeVariability: 'Cycle Time Variability',
  orderRequiringRevision: 'Orders Requiring Revisions',
  percentageOfBatchesInExtendedQc: 'Batches in Extended QC',
  numberOfStockOutIncidents: 'Stock-Out Incidents',
  numberOfExpiredInventoryBatches: 'Number of Expired Batches',
  percentageOfSkusAtLowStockLevel: 'SKUs at Low Stock',
  dataCompletenessRateConfirmations: 'Data Completeness - Confirmations',
  dataCompletenessRateOrders: 'Data Completeness - Orders',
  forecastRevisionRate: 'Forecast Revision Rate',
  avgFrequencyOfImports: 'Average Time Between Inventory Reports',
};

export interface PerformanceMetric {
  key: MetricKey;
  title: string;
  value: number;
  type: MetricType;
  trendStatus: PerformanceStatus;
  previousValue: number;
  change: number;
  additionalText?: string;
}

export interface PerformanceCategory {
  title: string;
  color: string;
  metrics: PerformanceMetric[];
}

export interface PerformanceMetricsParams {
  supplierId: string;
  timePeriod: PerformanceTimePeriod;
}

export interface PerformanceStatusCounts {
  improving: number;
  stable: number;
  declining: number;
}

export interface PerformanceMetricsResponse {
  categories: PerformanceCategory[];
  statusCounts: PerformanceStatusCounts;
}

export interface PerformanceMetricHistoryDataPoint {
  periodStart: string;
  periodEnd: string;
  value: number | null;
  meta: Record<string, unknown>;
}

export interface PerformanceMetricHistoryResponse {
  supplierPartnerId: string;
  metric: string;
  periodType: PerformanceTimePeriod;
  data: PerformanceMetricHistoryDataPoint[];
}

export interface PerformanceMetricHistoryParams {
  supplierId: string;
  metricKey: MetricKey;
  timePeriod: PerformanceTimePeriod;
}

export interface PerformanceMetricHistoryDialogData {
  metric: PerformanceMetric;
  supplierId: string;
  timePeriod: PerformanceTimePeriod;
  currentPeriod: string;
  previousPeriod: string;
}
